<template>
    <header class="py-3 bg-light">
        <div class="container">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
                <a href="/" class="col-4">
                    <img src="@/assets/logo.svg" alt="logo" class="img-fluid">
                </a>

                <div
                    class="rounded-4 bg-bd-green d-flex justify-content-center align-items-center gap-4 gap-lg-5 py-4 py-lg-3 col-7 col-md-5 col-lg-4 col-xl-3">
                    <h4 class="text-white pop700 my-auto">Get App</h4>
                    <a href="https://play.google.com/store/apps/details?id=com.getit.badidukkan" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none">
                            <path
                                d="M15.5791 12.4382L4.80273 1.63257L18.5137 9.50366L15.5791 12.4382ZM1.99023 0.997803C1.35547 1.32983 0.930664 1.9353 0.930664 2.72144V24.2693C0.930664 25.0554 1.35547 25.6609 1.99023 25.9929L14.5195 13.4929L1.99023 0.997803ZM22.752 12.0134L19.876 10.3484L16.668 13.4978L19.876 16.6472L22.8105 14.9822C23.6895 14.2839 23.6895 12.7117 22.752 12.0134ZM4.80273 25.363L18.5137 17.4919L15.5791 14.5574L4.80273 25.363Z"
                                fill="white" />
                        </svg>
                    </a>

                    <a href="" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none">
                            <path
                                d="M15.4414 11.8661C15.4316 10.0741 16.2422 8.72156 17.8828 7.72546C16.9648 6.41199 15.5781 5.68933 13.7471 5.54773C12.0137 5.41101 10.1191 6.55847 9.42578 6.55847C8.69336 6.55847 7.01367 5.59656 5.69531 5.59656C2.9707 5.6405 0.0751953 7.76941 0.0751953 12.1005C0.0751953 13.3798 0.30957 14.7014 0.77832 16.0653C1.40332 17.8573 3.65918 22.2518 6.0127 22.1786C7.24316 22.1493 8.1123 21.3046 9.71387 21.3046C11.2666 21.3046 12.0723 22.1786 13.4443 22.1786C15.8174 22.1444 17.8584 18.1503 18.4541 16.3534C15.2705 14.8544 15.4414 11.9589 15.4414 11.8661ZM12.6777 3.84851C14.0107 2.26648 13.8887 0.82605 13.8496 0.308472C12.6729 0.376831 11.3105 1.10925 10.5342 2.01257C9.67969 2.97937 9.17676 4.17566 9.28418 5.52332C10.5586 5.62097 11.7207 4.96667 12.6777 3.84851Z"
                                fill="white" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </header>
    <div class="container bg-dark">
        <nav class="d-flex justify-content-center py-3">
          <ul class="nav nav-pills">
            <li class="nav-item"><router-link to="/" class="btn pop300" aria-current="page">BadiDukkan</router-link></li>
            <li class="nav-item"><router-link to="/vendor" class="btn pop300">Vendor</router-link></li>
            <li class="nav-item"><router-link to="/rider" class="btn pop300">Rider</router-link></li>
          </ul>
        </nav>
      </div>
</template>

<style scoped>
.btn {
    color: white;
}

/* Darker background on mouse-over */
.router-link-active.router-link-exact-active{
    background-color: #70B224;
}

.router-link-active.router-link-exact-active:active{
    color: white;
}
</style>